import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SarFaslAmozeshiService } from 'src/app/Service/SarFaslAmozeshi/SarFaslAmozeshi.service';

@Component({
  selector: 'app-SarFaslAmozeshiAdd',
  templateUrl: './SarFaslAmozeshiAdd.component.html',
  styleUrls: ['./SarFaslAmozeshiAdd.component.scss']
})
export class SarFaslAmozeshiAddComponent implements OnInit {

  Token:String=""

  constructor(
    private SarFaslAmozeshi_Service:SarFaslAmozeshiService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewSarFaslAmozeshi=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,23).subscribe(
      data=>{
        
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewSarFaslAmozeshi:FormGroup;

  get_Form_Title(){
    return this.AddNewSarFaslAmozeshi.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewSarFaslAmozeshi(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    this.InProccessing=true
    this.SarFaslAmozeshi_Service.AddSarFaslAmozeshi(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
        }
        else{
          this.AddNewSarFaslAmozeshi.reset()
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      },error=>{
        localStorage.clear()
        location.reload();
        
      }
    )
  }



}
